import React from 'react'
import './Sevices.scss'

const Services = () => {
  return (
    <div>Services</div>
  )
}

export default Services